<template>

    <div v-if="stepVisible" class="offer__modal-step-wrapper">
        <ModalWrapper :stepValid="stepValid"
                      :hasBackBtn="true"
                      :title="'Dina uppgifter'"
                      :price="(price.isPriceRequest && price.priceLoaded && !price.priceError) && price.totalPrice || 0"
                      :enableHeaderOverlay="isDetailsOpen"
                      :priceRequestStatus="priceStatus"
                      :isPriceRequest="isPriceRequest"
                      @onNextStep="gotoNextStep"
                      @onPrevStep="gotoPrevStep">

            <PriceDetailsUser  @openDetails="onOpenDetails"  />
            
            <div class="offer__modal-container offer__user-form">
                <div id="offer-user-form">

                    <div v-if="price.isPriceRequest && price.priceError && !hidePrice" class="offer__user-form__error">
                        <div style="font-weight:500;">
                            {{texts.carform.noPriceFound}}
                        </div>
                    </div>

                    <div class="offer__input-container-wrapper">

                        <div class="offer__input-container-60">
                            <i class="fal fa-user offer__input-icon"></i>
                            
                            <input type="text" v-model="firstname" placeholder="Förnamn"
                                   minlength="2"
                                   maxlength="60"
                                   required id="offer-firstname" />
                            <i class="far fa-check"></i>
                            
                        </div>

                        <div class="offer__input-container-40">
                            <i class="fal fa-user offer__input-icon"></i>
                            <input type="text" v-model="lastname" placeholder="Efternamn"
                                   minlength="2"
                                   maxlength="100"
                                   required />
                            <i class="far fa-check"></i>
                        </div>

                        <div class="offer__input-container-60">
                            <i class="fal fa-at offer__input-icon"></i>
                            <input type="email" v-model="email" placeholder="E-post"
                                   required />
                            <i class="far fa-check"></i>
                        </div>

                        <div class="offer__input-container-40">
                            <i class="fal fa-mobile offer__input-icon"></i>
                            <input type="text" v-model="phone" placeholder="Telefon"
                                   minlength="7"
                                   maxlength="20"
                                   required 
                                   />
                            <i class="far fa-check"></i>
                        </div>
                    </div>

                    <div class="offer__input-container-wrapper" v-if="showCompanyInputBox">
                        <div class="offer__input-container-60">
                            <i class="fal fa-building offer__input-icon"></i>
                            <input v-if="isCompanyInputBoxRequred" type="text" v-model="company" placeholder="Företagsnamn"
                                   minlength="2"
                                   maxlength="100"
                                   required />
                            <input v-else type="text" v-model="company" placeholder="Företagsnamn"
                                   minlength="2"
                                   maxlength="100" />
                            <i v-if="isCompanyInputBoxRequred" class="far fa-check"></i>
                        </div>
                    </div>

                    <div class="offer__input-container-100">
                        <i class="fal fa-envelope offer__input-icon"></i>
                        <textarea v-model="message" placeholder="Meddelande" maxlength="1500" />
                    </div>

                    
                </div>

            </div>
        </ModalWrapper>

    </div>

</template>

<script>

    import { mapState, mapActions } from 'vuex';
    import steps from '../constants/steps';
    import PriceDetailsUser from './PriceDetailsUser.vue';
    import ModalWrapper from './ModalWrapper.vue';
    import axios from 'axios';

    export default {
        name: 'userFormStep',
        components: {
            PriceDetailsUser,
            ModalWrapper,
        },
        data() {
            return {
                stepValid: false,
                isDetailsOpen: false,
                trackedPrice: 0,
            };
        },
        computed: {
            ...mapState({
                stepProgress: state => state.stepProgress,
                input: state => state.user.input,
                price: state => state.price,
                selectedServicesIds: state => state.selectedServices.ids,
                texts: state => state.config.texts,
                car: state => state.car,
                workshopId: state => state.workshop.selectedWorkshopId,
                hidePrice: state => state.config.disablePrices,
                showCompanyInputBox: state => state.config.showCompanyInputBox,
                isCompanyInputBoxRequred: state => state.config.isCompanyInputBoxRequred,
            }),
            stepVisible: {
                get() {
                    return (this.stepProgress.currentStep == steps.userFormStep);
                },
            },
            priceStatus: {
                get() {
                    return this.price.servicePriceState.status
                }
            },
            isPriceRequest: {
                get() {
                    return this.price.isPriceRequest
                }
            },
            firstname: {
                get() {
                    return this.input.firstname;
                },
                set(value) {
                    this.$store.commit('user/firstname', value);
                    this.validateAllFields();
                }
            },
            lastname: {
                get() {
                    return this.input.lastname;
                },
                set(value) {
                    this.$store.commit('user/lastname', value);
                    this.validateAllFields();
                }
            },
            email: {
                get() {
                    return this.input.email;
                },
                set(value) {
                    this.$store.commit('user/email', value);
                    this.validateAllFields();
                }
            },
            phone: {
                get() {
                    return this.input.phone;
                },
                set(value) {
                    this.$store.commit('user/phone', value);
                    this.validateAllFields();
                }
            },
            company: {
                get() {
                    return this.input.company;
                },
                set(value) {
                    this.$store.commit('user/company', value);
                    this.validateAllFields();
                }
            },
            message: {
                get() {
                    return this.input.message;
                },
                set(value) {
                    this.$store.commit('user/message', value);
                }
            },
            servicePriceStatus: {
                get() {
                    return this.price.servicePriceState.status;
                }
            },
            workshopServicesStatus: {
                get() {
                    return this.price.workshopServices.status;
                }
            },
            priceError: {
                get() {
                    return this.price.priceError;
                }
            },
        },
        watch: {
            servicePriceStatus() {
                this.$store.commit('price/checkPriceStates', this.selectedServicesIds);
                this.triggerUpdatePrePayment();
                this.tryTrackPrice();
            },
            workshopServicesStatus() {
                this.$store.commit('price/checkPriceStates', this.selectedServicesIds);
                this.triggerUpdatePrePayment();
                this.tryTrackPrice();
            },
            stepVisible(visible) {
                if (visible)
                    setTimeout(function () { document.getElementById('offer-firstname').focus() }.bind(this), 100);
            },
            priceError(value) {
                if (value)
                    this.trackPriceError();
            }
        },
        methods: {
            ...mapActions({
                switchStep: 'stepProgress/switchToStep',
            }),
            gotoNextStep() {
                this.trackSuccess();
                this.switchStep(steps.confirmStep);
            },
            gotoPrevStep() {
                this.switchStep(steps.workshopStep);
            },
            onOpenDetails(isDetailsOpen) {
                this.isDetailsOpen = isDetailsOpen;
            },
            validateAllFields() {
                let valid = true;
                document.querySelectorAll('#offer-user-form input').forEach((el) => {
                    if (!el.checkValidity()) {
                        valid = false;
                    }
                }); 
                this.stepValid = valid;
            },
            trackSuccess() {
                this.$store.commit('config/trackAction',
                    {
                        event: 'trackNewCustomerInfoSuccess',
                        data: { selectedCar: this.selectedCar, customerInfoSuccess: 1 },
                    });
            },
            tryTrackPrice() {
                if (this.priceLoaded) {
                    let price = Math.round(this.price.totalPrice);
                    if (price != this.trackedPrice && price > 0)
                        this.$store.commit('config/trackAction',
                            {
                                event: 'trackNewViewedFixedPrice',
                                data: { price: price },
                            });
                        this.trackedPrice = price;
                }
            },
            triggerUpdatePrePayment() {
                let url = '/api/applications/offers/getprepaymentinfo?price=' + encodeURIComponent(this.price.totalPrice);
                axios.get(url).
                    then(r => {
                        this.$store.commit('price/updatePartPayment', r.data);
                    });
            },
            trackPriceError() {
                this.$store.commit('config/trackAction',
                    {
                        event: 'trackNewFailedFixedPrice',
                        data: {
                            regNo: this.car.pickCarState.data.regNo,
                            selectedService: this.car.selectedService,
                            miles: this.car.miles,
                            workshopId: this.workshopId
                        },
                    });
            }
        },
    }

</script>
